import { SET_TRANSLATIONS } from "./actionTypes";

const initialState = {
  translations: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSLATIONS:
      return {
        ...state,
        translations: action.payload || [],
      };
    default:
      break;
  }
  return state;
};

export default reducer;